import React, { useEffect, useState } from "react";

const LoadingDots = ({ loadingText }) => {
  const [dots, setDots] = useState(1);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDots((prevDots) => (prevDots % 3) + 1);
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  const dotsString = ". ".repeat(dots);

  // If called without loadingText (e.g. AuthLayout route guard), render full-screen brand loader
  if (!loadingText) {
    return (
      <div
        className="fixed inset-0 w-screen h-screen flex flex-col items-center justify-center bg-[#FAF6EE] z-[999999]"
        style={{ backgroundColor: "#FAF6EE" }}
      >
        <div className="flex flex-col items-center gap-4">
          <div className="w-11 h-11 border-4 border-slate-200 border-t-purple-600 rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  return (
    <>
      {loadingText} {dotsString}
    </>
  );
};

export default LoadingDots;
